import { render, staticRenderFns } from "./zmdetNav.vue?vue&type=template&id=827c4a58&"
import script from "./zmdetNav.vue?vue&type=script&lang=js&"
export * from "./zmdetNav.vue?vue&type=script&lang=js&"
import style0 from "./zmdetNav.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports